export const testimonialsData = [
  {
    id: 1,
    name: '田中 美咲',
    position: '地元サッカークラブ 保護者代表',
    comment: '息子の卒団記念にマグカップを作っていただきました。子どもたちの名前を一つ一つ丁寧に印刷してくださり、とても喜んでいました。親身に相談に乗っていただき、本当に感謝しています。',
    rating: 5,
    image: 'https://public.readdy.ai/ai/img_res/8df5e03a578212e58dbec968d1ae007a.jpg',
  },
  {
    id: 2,
    name: '佐藤 健太',
    position: '株式会社山陽商事 営業部長',
    comment: '会社の販促物を毎年お願いしています。いつも期待以上の仕上がりで、クライアントからも好評です。納期も守っていただけるので安心してお任せできます。',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20Japanese%20businessman%20in%20his%2050s%20wearing%20a%20business%20suit%20with%20a%20confident%20smile%20in%20a%20modern%20office%20environment%20with%20soft%20lighting%20and%20a%20neutral%20clean%20background&width=400&height=400&seq=testimonial002&orientation=squarish',
  },
  {
    id: 3,
    name: '山本 由美',
    position: 'カフェオーナー',
    comment: 'お店のオリジナルマグカップを制作していただきました。デザインの相談から丁寧に対応してくださり、イメージ通りの素敵な仕上がりになりました。お客様にも大変喜ばれています。',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20cheerful%20Japanese%20woman%20in%20her%2030s%20with%20a%20bright%20smile%20wearing%20casual%20stylish%20clothing%20in%20a%20cozy%20cafe%20setting%20with%20warm%20lighting%20and%20a%20soft%20blurred%20background&width=400&height=400&seq=testimonial003&orientation=squarish',
  },
  {
    id: 4,
    name: '鈴木 誠',
    position: '地元イベント実行委員長',
    comment: '地域イベントのTシャツを大量に発注しましたが、短納期にも関わらず高品質な仕上がりでした。価格も良心的で、また次回もお願いしたいと思います。',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20friendly%20Japanese%20man%20in%20his%2040s%20with%20a%20warm%20smile%20wearing%20casual%20clothing%20in%20an%20outdoor%20community%20event%20setting%20with%20natural%20daylight%20and%20a%20simple%20clean%20background&width=400&height=400&seq=testimonial004&orientation=squarish',
  },
];
